

import React, { useEffect, useState } from 'react';
import call from '../../service';
import toastDisplay from '../../utils/toastNotification';

const InvestigationRemark = ({ userTokenDetails, setshowInvestigationRemark, showInvestigationRemark, setrefresh, refresh }) => {
  //---------------------------------------------------------------------------------------------------------------------
  //States
  const [agency, setAgency] = useState([]);
  const [data, setData] = useState({ importerUser: [], exporterUser: [], thirdPartyUser: [] });
  const [showLoader, setshowLoader] = useState(false);
  const contractData = showInvestigationRemark.contractData;

  const userTypeId = userTokenDetails.type_id ? userTokenDetails.type_id : null
  const userId = userTokenDetails.user_id ? userTokenDetails.user_id : null
  //---------------------------------------------------------------------------------------------------------------------
  // use effects
  useEffect(() => {

    //------------------------------------------------------------------
    //API Calls
    setshowLoader(true);
    call('POST', 'getAgencys', { traderId: (userTypeId === 14 ? userId : contractData.importer_id) }).then((result) => {
      setshowLoader(false);
      setAgency(result)
    }).catch((e) => {
      console.log("Error while querying getAgencys:", e);
    })
    //------------------------------------------------------------------

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //---------------------------------------------------------------------------------------------------------------------

  //---------------------------------------------------------------------------------------------------------------------
  // Handlers
  const handleChange = (event) => {
    event.persist();
    setData(data => ({ ...data, [event.target.name]: event.target.value }));
  }

  const handleCheckbox = (event) => {
    event.persist();
    let tempArray = data[event.target.name] ? [...data[event.target.name]] : []
    let selectedUser = event.target.value / 1
    let index = tempArray.indexOf(selectedUser)
    if (index !== -1) {
      tempArray = tempArray.slice(0, index)
    } else {
      tempArray.push(selectedUser / 1)
    }
    setData(data => ({ ...data, [event.target.name]: tempArray }));
  }

  const handleCheckAllImporterInvestigation = (event) => {
    event.persist();
    let tempArray = [...data.importerUser]
    for (let i = 0; i < agency.length; i++) {
      if (!tempArray.includes(agency[i])) {
        tempArray.push(agency[i].tbl_user_id)
      }
    }
    setData(data => ({ ...data, importerUser: tempArray }));
  }

  const handleCheckAllExporterInvestigation = (event) => {
    event.persist();
    let tempArray = [...data.exporterUser]
    for (let i = 0; i < agency.length; i++) {
      if (!tempArray.includes(agency[i])) {
        tempArray.push(agency[i].tbl_user_id)
      }
    }
    setData(data => ({ ...data, exporterUser: tempArray }));
  }

  const handleCheckAllThirdPartyInvestigation = (event) => {
    event.persist();
    let tempArray = [...data.thirdPartyUser]
    for (let i = 0; i < agency.length; i++) {
      if (!tempArray.includes(agency[i])) {
        tempArray.push(agency[i].tbl_user_id)
      }
    }
    setData(data => ({ ...data, thirdPartyUser: tempArray }));
  }

  //---------------------------------------------------------------------------------------------------------------------

  console.log("data in request =>", data)
  //---------------------------------------------------------------------------------------------------------------------
  // Submit handler
  function handleSubmitQuoat() {

    let formData = new FormData();

    formData.append("sendToImporterUsers", data.importerUser);
    formData.append("sendToExporterUsers", data.exporterUser);
    formData.append("sendToThirdPartyUsers", data.thirdPartyUser);
    formData.append("contractId", showInvestigationRemark.contract_id);
    formData.append("contractNo", showInvestigationRemark.contract_no);

    setshowLoader(true)
    call('POST', 'raiseInvestigationQuotation', formData).then((result) => {
      setrefresh(refresh + 1)
      setshowLoader(false)
      setshowInvestigationRemark({ modal: false })
    }).catch((e) => {
      setshowLoader(false)
      console.log("Error while raising quotation request:", e);
      toastDisplay(e, "error")
    })

  }


  //---------------------------------------------------------------------------------------------------------------------


  return (
    <>
      {showInvestigationRemark.modal && <div className={"modal" + (showInvestigationRemark.modal ? " show" : "")} id="DocumentUpload">
        <div className="modal-dialog modal-xl border-inner" id="parent_class">
          <div className="modal-content">
            <div className="modal-header primary">
              <h4 className="modal-title text-white">Send Investigation Quotation</h4>
              <button type="button" className="close" onClick={() => { setshowInvestigationRemark(false) }}>×</button>
            </div>
            <div className="modal-body calc-inner-modal">
              {showLoader === true && (<div className="loading-overlay"><span><img className="" src="assets/images/loader.gif" alt="description" /></span></div>)}

              <div className=" col-md-12 row" >

                <div className="col-md-12">
                  <ul className="price-ul">
                    <li>
                      <div className="price-left">{contractData.contract_name}</div>
                      <div className="price-right">Contract </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.buyername}</div>
                      <div className="price-right">Importer </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.suppliername}</div>
                      <div className="price-right">Exporter </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.commodity_name}</div>
                      <div className="price-right">Commodity </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.quantity}</div>
                      <div className="price-right">Quantity </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.laycan_start}</div>
                      <div className="price-right">Laycan Start </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.laycan_end}</div>
                      <div className="price-right">Laycan End </div>
                    </li>
                    <li>
                      <div className="price-left">{contractData.created_at}</div>
                      <div className="price-right">Created at </div>
                    </li>
                  </ul>
                </div>

                <div className=" col-md-12 row mt-4">
                  <div className=" col-md-4">
                    <label >Select Importer's Investigation Agency</label>
                    {(agency.length > 1) &&
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="checkAll" name="importerCheckAll" id="importerCheckAll" onChange={handleCheckAllImporterInvestigation} />
                        <label className="form-check-label" htmlFor="importerCheckAll">"Check All"</label>
                      </div>
                    }
                    {agency && agency.length ? agency.map((user, index) => {
                      return (
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value={user.tbl_user_id} name="importerUser" id={"importerUser" + index} onChange={handleCheckbox} checked={data.importerUser.includes(user.tbl_user_id)} />
                          <label className="form-check-label" htmlFor={"importerUser" + index}>{user.company_name}</label>
                        </div>
                      )
                    }) : ""
                    }
                  </div>
                  <div className=" col-md-4">
                    <label >Select Exporter's Investigation Agency</label>
                    {(agency.length > 1) &&
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="checkAll" name="exporterCheckall" id="exporterCheckall" onChange={handleCheckAllExporterInvestigation} />
                        <label className="form-check-label" htmlFor="exporterCheckall">"Check All"</label>
                      </div>
                    }
                    {agency && agency.length ? agency.map((user, index) => {
                      return (
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value={user.tbl_user_id} name="exporterUser" id={"exporterUser" + index} onChange={handleCheckbox} checked={data.exporterUser.includes(user.tbl_user_id)} />
                          <label className="form-check-label" htmlFor={"exporterUser" + index}>{user.company_name}</label>
                        </div>
                      )
                    }) : ""
                    }
                  </div>
                  <div className=" col-md-4">
                    <label >Select Third Party Investigation Agency</label>
                    {(agency.length > 1) &&
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="checkAll" name="thirdPartyCheckall" id="thirdPartyCheckall" onChange={handleCheckAllThirdPartyInvestigation} />
                        <label className="form-check-label" htmlFor="thirdPartyCheckall">"Check All"</label>
                      </div>
                    }
                    {agency && agency.length ? agency.map((user, index) => {
                      return (
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value={user.tbl_user_id} name="thirdPartyUser" id={"thirdPartyUser" + index} onChange={handleCheckbox} checked={data.thirdPartyUser.includes(user.tbl_user_id)} />
                          <label className="form-check-label" htmlFor={"thirdPartyUser" + index}>{user.company_name}</label>
                        </div>
                      )
                    }) : ""
                    }
                  </div>

                </div>
              </div>
            </div>
            <div className="modal-footer primary">
              <button type="button" className="btn btn-primary btn-sm float-right" onClick={() => handleSubmitQuoat()} >Submit</button>
            </div>
          </div>
        </div>
      </div >}
    </>)
}


export default InvestigationRemark